import { Cookies } from "react-cookie";
import { StoreKey } from "../models/cacheKey";
import { Base64 } from "js-base64";
import { createStore } from "jotai";

const cookies = new Cookies(null, { path: "/" });

export function SetSessionToken(sessionToken: string) {
  const splitToken = sessionToken.split(".");
  if (splitToken.length === 3) {
    const data = JSON.parse(Base64.decode(splitToken[1]));
    cookies.set(StoreKey.sessionToken, sessionToken, {
      expires: new Date(data.exp * 1000),
    });
  }
}

export function GetSessionToken() {
  return cookies.get(StoreKey.sessionToken);
}

export function RemoveSessionToken() {
  return cookies.remove(StoreKey.sessionToken);
}

export function GetBackstageToken() {
  return cookies.get(StoreKey.backstageToken + process.env.REACT_APP_ENV);
}

export const store = createStore();
